/** Detectar si un error es de red (fetch failed, timeout, etc.) */
export function isNetworkError(e: any): boolean {
  if (typeof navigator !== 'undefined' && !navigator.onLine) return true
  if (!e) return false
  const msg = (e?.message || '').toLowerCase()
  return (
    msg.includes('failed to fetch') ||
    msg.includes('load failed') ||
    msg.includes('networkerror') ||
    msg.includes('network request failed') ||
    msg.includes('timeout') ||
    msg.includes('aborted') ||
    e?.code === 'NETWORK_ERROR'
  )
}
